module.exports = __webpack_public_path__ + "assets/977b769fe907214e93d5495db5cc5804.mp3";